<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th>Usuario</th>
              <th>Tipo</th>
              <th>Teléfono</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><div class="flex items-center gap-2"><p-skeleton shape="circle" size="2.5rem" /><p-skeleton width="7rem" height="0.875rem" /><p-skeleton width="5rem" height="0.75rem" class="mt-1" /></div></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right w-[100px]"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadUsers()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  <!-- Tabla PrimeNG: siempre visible tras primera carga -->
  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-users"></i>
                </span>
                Usuarios
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de usuarios del sistema.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <a routerLink="/users/nuevo" class="inline-block" appDisableUnless="USER_WRITE">
                <p-button label="Nuevo usuario" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="USER_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterUsersQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterUsersQ">Nombre o correo</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterUsersState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterUsersState">Estatus</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="users()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuarios"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="users-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end">
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2" pSortableColumn="name">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Usuario</span>
                    @if (sortField() === 'name') {
                      <p-sortIcon field="name" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="type">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Tipo</span>
                    @if (sortField() === 'type') {
                      <p-sortIcon field="type" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="phone">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Teléfono</span>
                    @if (sortField() === 'phone') {
                      <p-sortIcon field="phone" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openUserDetails(user)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div class="shrink-0 h-8 w-8 rounded-full flex items-center justify-center [&>i]:text-sm"
                      [class.bg-purple-100]="user.type === UserType.OWNER"
                      [class.text-purple-600]="user.type === UserType.OWNER"
                      [class.bg-sky-100]="user.type !== UserType.OWNER"
                      [class.text-sky-600]="user.type !== UserType.OWNER">
                      <i class="pi pi-user"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ getDisplayName(user) }}</div>
                      @if (user.jobTitle) {
                        <div class="text-xs text-slate-500 truncate">{{ user.jobTitle }}</div>
                      }
                      <div class="text-xs text-slate-500 truncate">{{ user.email }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full"
                    [class.bg-purple-100]="user.type === UserType.OWNER"
                    [class.text-purple-800]="user.type === UserType.OWNER"
                    [class.bg-slate-100]="user.type === UserType.USER"
                    [class.text-slate-800]="user.type === UserType.USER">
                    {{ getTypeLabel(user.type!) }}
                  </span>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap">{{ user.phone || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()" pFrozenColumn>
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" rounded [text]="true" severity="secondary" styleClass="hover:!bg-sky-100" (onClick)="editUser(user, $event)" appDisableUnless="USER_WRITE" />
                    <p-button
                      icon="pi pi-trash"
                      rounded
                      [text]="true"
                      severity="danger"
                      [disabled]="user.type === UserType.OWNER"
                      [matTooltip]="user.type === UserType.OWNER ? 'No se puede eliminar al propietario de la cuenta' : ''"
                      (onClick)="openDeleteModal(user, $event)"
                      appDisableUnless="USER_DELETE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron usuarios con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="user-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <h3 class="text-lg font-semibold text-slate-900">Detalles del usuario</h3>
        @if (selectedUser() && !detailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando usuario...</p>
      </div>
    } @else if (selectedUser()) {
      <app-user-read [user]="selectedUser()!" />
    }
  </p-drawer>

  @if (deleteModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
        [class.bg-opacity-50]="deleteModalShown()" [class.bg-opacity-0]="!deleteModalShown()"
        (click)="closeDeleteModal()"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10 transform transition-all duration-300 ease-out"
        [class.opacity-100]="deleteModalShown()" [class.opacity-0]="!deleteModalShown()"
        [class.scale-100]="deleteModalShown()" [class.scale-95]="!deleteModalShown()">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-slate-900">Confirmar eliminación</h3>
          <button type="button" class="text-slate-500 hover:text-slate-700" (click)="closeDeleteModal()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <p class="text-sm text-slate-600 mb-6">
          ¿Está seguro de eliminar al usuario "{{ userToDelete()?.email }}"? Esta acción no se puede deshacer.
        </p>
        <div class="flex justify-end gap-3">
          <button type="button" mat-stroked-button (click)="closeDeleteModal()">Cancelar</button>
          <button type="button" mat-raised-button color="warn" [disabled]="deleteLoading()"
            (click)="confirmDeleteUser()">
            {{ deleteLoading() ? 'Eliminando...' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
